import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives/directives.module';
import { CreateProjectDialogModule } from '../create-project-dialog';
import { CreateWizardModule } from '../create-wizard';
import { ObjectBrowserModule } from '../object-browser';
import { SelectExistingProjectComponent } from '../select-existing-project/select-existing-project.component';
import { AddDataComponent } from './add-data.component';
import { AddLayerOptionsComponent } from './add-layer-options/add-layer-options.component';
import { SelectDataTypeComponent } from './select-data-type/select-data-type.component';

@NgModule({
    declarations: [AddDataComponent, SelectDataTypeComponent, SelectExistingProjectComponent, AddLayerOptionsComponent],
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        CreateProjectDialogModule,
        CreateWizardModule,
        ObjectBrowserModule,
        DirectivesModule,
    ],
})
export class AddProjectModule {}
